import React, {Component} from "react";
import {Form, Input , Radio,Row,Col} from 'antd';
import NHFetch from "../../../utils/NHFetch";

const FormItem = Form.Item;

const baseUrlPath = "/swbl/lstd"; //基础路径

/**
 * 绿色通道查看表单
 * @author admin
 * @date 2018-03-16 11:28:34
 * Version: 1.0
 */
class ViewForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    componentWillMount(){
       
    }

   
    render() {
        const initFormData = this.props.initFormData;

        return (
            <div>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}> 姓名(学号)：</Col>
                    <Col span={8}>{initFormData.XH?`${initFormData.XM}(${initFormData.XH})`:''}</Col>
                    <Col span={4} style={{textAlign:'right'}}>性别：</Col>
                    <Col span={8}>{initFormData.XB}</Col>
                    <Col span={4} style={{textAlign:'right'}}>身份证号：</Col>
                    <Col span={8}>{initFormData.SFZJH}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}> 籍贯：</Col>
                    <Col span={8}>{initFormData.JG}</Col>
                    <Col span={4} style={{textAlign:'right'}}>民族：</Col>
                    <Col span={8}>{initFormData.MZ}</Col>
                    <Col span={4} style={{textAlign:'right'}}>所在宿舍：</Col>
                    <Col span={8}>{initFormData.SZSS}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>学院：</Col>
                    <Col span={8}>{initFormData.BMMC}</Col>
                    <Col span={4} style={{textAlign:'right'}}>专业：</Col>
                    <Col span={8}>{initFormData.ZYMC}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>班级：</Col>
                    <Col span={8}>{initFormData.BJMC}</Col>
                    <Col span={4} style={{textAlign:'right'}}>年度：</Col>
                    <Col span={8}>{initFormData.ND}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>家庭住址：</Col>
                    <Col span={8}>{initFormData.JTDZ}</Col>
                    <Col span={4} style={{textAlign:'right'}}>联系电话：</Col>
                    <Col span={8}>{initFormData.SJHM}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>缓交金额：</Col>
                    <Col span={8}>{initFormData.HJJE}元</Col>
                    <Col span={4} style={{textAlign:'right'}}>学费缓交：</Col>
                    <Col span={8}>{initFormData.XFHJ}元</Col>
                    <Col span={4} style={{textAlign:'right'}}>住宿费缓交：</Col>
                    <Col span={8}>{initFormData.ZSFHJ}元</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>办理原因：</Col>
                    <Col span={20}>{initFormData.SQSM}</Col>
                </Row>
                  {initFormData.SHZT!='未审核' && <div>
                    <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                        <Col span={4} style={{textAlign:'right'}}>审核状态：</Col>
                        <Col span={8}>{initFormData.SHZT}</Col>
                        <Col span={4} style={{textAlign:'right'}}>审核时间：</Col>
                        <Col span={8}>{initFormData.SHSJ}</Col>
                    </Row>
                    <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                        <Col span={4} style={{textAlign:'right'}}>审核意见：</Col>
                        <Col span={20}>{initFormData.SHYJ}</Col>
                    </Row>
                </div>}
            </div>
        );
    }
}

export default ViewForm;


// WEBPACK FOOTER //
// ./components/swbl/ztxyLstd/ViewForm.js